import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from '@griply/types';
import { LifeArea } from 'shared/types/life-area';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const getDefaultFilterDocument = (
  lifeArea?: LifeArea,
): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Section,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.LifeArea]: { include: [lifeArea?.id ?? ''] },
  },
});
